<defs>
    <marker id="markerArrow" markerWidth="13" markerHeight="13" refX="8" refY="7" orient="auto" markerUnits="userSpaceOnUse">
        <path d="M2,2 L2,13 L8,7 L2,2" style="fill: #000000;"></path>
    </marker>
</defs>

<defs>
    <marker id="markerArrowHighlighted" markerWidth="13" markerHeight="13" refX="8" refY="7" orient="auto" markerUnits="userSpaceOnUse">
        <path d="M2,2 L2,13 L8,7 L2,2" style="fill: coral;"></path>
    </marker>
</defs>